import styled, { css } from 'styled-components';
import { getColor, getColorShade, getSizeBy } from '../../../src/styled/utils';
import { Body2Styles, Subtitle2Styles } from '../typography';
import { Button } from '../button';
const sizeLiteral = { small: 5, medium: 6 };
const getChipBackgroundColor = (variant, disabled) => {
    if (disabled) {
        return getColorShade('onSurface', 'selected');
    }
    switch (variant) {
        case 'transparent': {
            return 'transparent';
        }
        case 'selected':
            return getColorShade('primary', 'selected');
        case 'hover':
            return getColorShade('primary', 'hover');
        case 'default':
        default:
            return getColor('surface');
    }
};
const getChipInputBackgroundColor = (variant, disabled) => {
    if (disabled) {
        return getColorShade('onSurface', 'selected');
    }
    switch (variant) {
        case 'hover':
            return getColorShade('primary', 'pressed');
        case 'default':
        default:
            return getColor('tertiary');
    }
};
const getChipTextColor = (variant, disabled) => {
    if (disabled || variant === 'default' || variant === 'transparent') {
        return getColorShade('onSurface', 'mediumEmphasis');
    }
    return getColorShade('onSurface', 'highEmphasis');
};
const getChipInputTextColor = (variant, disabled) => {
    if (variant === 'hover' && !disabled) {
        return getColorShade('onSurface', 'highEmphasis');
    }
    return getColorShade('onSurface', 'mediumEmphasis');
};
export const TextWrap = styled.span `
  ${({ sizeComponent }) => (sizeComponent == 'small' ? Subtitle2Styles : Body2Styles)};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
export const StyledButton = styled(Button) `
  position: relative;
  padding: 0;
`;
export const ChipWrapperCommon = css `
  display: grid;
  grid-template-columns: 1fr auto;
  align-content: center;
  align-items: center;
  height: ${({ sizeComponent }) => getSizeBy(sizeLiteral[sizeComponent])};
  border-radius: ${getSizeBy(3 / 4)};
  cursor: default;

  & path {
    fill: ${({ disabled }) => disabled
    ? getColorShade('onSurface', 'outline')
    : getColorShade('onSurface', 'mediumEmphasis')};
  }
`;
export const StyledChipWrapper = styled.div.attrs({
    'data-testid': 'chip'
}) `
  ${ChipWrapperCommon};
  padding: ${getSizeBy(0.5)} ${getSizeBy(2)} ${getSizeBy(0.5)} ${getSizeBy(2)};
  background-color: ${({ variant, disabled }) => getChipBackgroundColor(variant, disabled)};
  border: ${({ disabled, theme }) => disabled ? 'none' : `1px solid ${getColorShade('onSurface', 'outline')({ theme })}`};

  &:hover {
    background-color: ${({ disabled }) => getChipBackgroundColor('hover', disabled)};
    & > ${TextWrap} {
      color: ${({ disabled }) => getChipTextColor('hover', disabled)};
    }
  }

  & > ${TextWrap} {
    color: ${({ variant, disabled }) => getChipTextColor(variant, disabled)};
  }
`;
export const StyledChipInputWrapper = styled.div.attrs({
    'data-testid': 'chip-input'
}) `
  ${ChipWrapperCommon};
  gap: ${getSizeBy(1 / 2)};
  padding: ${getSizeBy(0.5)} ${getSizeBy()} ${getSizeBy(0.5)} ${getSizeBy(2)};
  background-color: ${({ variant, disabled }) => getChipInputBackgroundColor(variant, disabled)};
  border: ${({ disabled, theme }) => disabled ? 'none' : `1px solid ${getColorShade('onSurface', 'outline')({ theme })}`};

  &:hover {
    background-color: ${({ disabled }) => getChipInputBackgroundColor('hover', disabled)};
    & > ${TextWrap} {
      color: ${({ disabled }) => getChipInputTextColor('hover', disabled)};
    }
    & > ${StyledButton} > svg {
      color: ${({ disabled }) => getChipInputTextColor('hover', disabled)};
    }
  }

  & > ${StyledButton} > svg {
    color: ${({ disabled, variant }) => getChipInputTextColor(variant, disabled)};
  }

  & > ${TextWrap} {
    color: ${({ variant, disabled }) => getChipInputTextColor(variant, disabled)};
  }
`;
